import CompoundEvent from 'session/CompoundEvent.js';
import Tone from 'tone';
import {SEQUENCE_ROLL,
       RESOLUTION_CHANGE} from 'session/constants.js';
import ResolutionChangeEvent from 'session/ResolutionChangeEvent.js';
import Resolution from 'engine/Resolution.js';

class SequenceRollEvent extends CompoundEvent {
    constructor(rolling, resolution) {
        super(new ResolutionChangeEvent(resolution));
        this.rolling = rolling;
    }

    getValue() {
        return this.rolling ? 1 : 0;
    }

    isDeterministic() {
        return true;
    }

    isSkippable() {
        return true;
    }

    isPrunable() {
        return !this.rolling;
    }

    executeEvent(sequencerEngine) {
        sequencerEngine.sequenceRolling = this.rolling;
    }

    getCopy() {
        let pattern = new SequenceRollEvent(this.rolling, this.initialSubEvent.resolution);
        pattern.fromJson(this.getJson());
        return pattern;
    }

    getType() {
        return SEQUENCE_ROLL;
    }

    getSubType() {
        return RESOLUTION_CHANGE;
    }

    getJson() {
        return {
            ... super.getJson(),
            rolling: this.rolling
        };
    }

    fromJson(json, sequencerEngine) {
        super.fromJson(json);
        this.rolling = json.rolling;
        this.initialSubEvent.step = this.step;
        return this;
    }
}

export default SequenceRollEvent;

